import(/* webpackMode: "eager", webpackExports: ["CursorGlow"] */ "/vercel/path0/app/[locale]/_landing/CursorGlow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturesCarousel"] */ "/vercel/path0/app/[locale]/_landing/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FinalCTA"] */ "/vercel/path0/app/[locale]/_landing/FinalCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroCanvasBg"] */ "/vercel/path0/app/[locale]/_landing/HeroCanvasBg.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorks"] */ "/vercel/path0/app/[locale]/_landing/HowItWorks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LiveDemoCard"] */ "/vercel/path0/app/[locale]/_landing/LiveDemoCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/vercel/path0/app/[locale]/_landing/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PillButton"] */ "/vercel/path0/app/[locale]/_landing/PillButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pricing"] */ "/vercel/path0/app/[locale]/_landing/Pricing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TitleRotator"] */ "/vercel/path0/app/[locale]/_landing/TitleRotator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
